import React from "react";

import NumberInput from "@cayuse/shared-react.components.form.inputs.number";
import Table from "components/Table";
import PropTypes from "prop-types";


export const EditableTableCell = (
	{
		value,
		editable,
		onChange,
		textFormatter,
		cellStyles,
		inputStyles,
		renderInput,
		hideContent
	}
) =>
	<Table.Cell className={cellStyles}>
		{!hideContent && <>
			{editable && renderInput({value: value || "", onChange, className: inputStyles})}
			{!editable && textFormatter(value)}
		</>}
	</Table.Cell>;

EditableTableCell.defaultProps = {
	hideContent: false,
	textFormatter: value => value,
	value: null,
	onChange: () => {
	},
	renderInput: props =>
		(
			<NumberInput
				{...props}
			/>
		)
};
EditableTableCell.propTypes = {
	cellStyles: PropTypes.any,
	editable: PropTypes.bool.isRequired,
	hideContent: PropTypes.bool,
	inputStyles: PropTypes.any,
	onChange: PropTypes.func,
	renderInput: PropTypes.func,
	textFormatter: PropTypes.func,
	value: PropTypes.any,
};
